export const AUTH_TOKEN = "AUTH_TOKEN"
export const SCHOOL_ID = "SCHOOL_ID"
export const PERMISSIONS = "PERMISSIONS"
export const SESSION_EXPIRED = "SESSION_EXPIRED"
export const SHOW_SOLVER_MODAL = "SHOW_SOLVER_MODAL"
export const REGION = "REGION"
export const TEACHER_ID = "TEACHER_ID"
